// extracted by mini-css-extract-plugin
module.exports = {"address":"Address_address__PNxbS","icon":"Address_icon__MdXVa"};